(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
  const hero = document.getElementById('Hero-{{ section.id }}');
  if (!hero) return;
  const images = Array.from(hero.querySelectorAll('.hero__media-grid img, .hero__media-grid picture'));
  if (images.length < 2) return;

  // Mezclar aleatoriamente
  for (let i = images.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [images[i], images[j]] = [images[j], images[i]];
  }

  let current = 0;
  images.forEach((img, i) => {
    img.style.transition = 'opacity 1s ease';
    img.style.position = 'absolute';
    img.style.inset = '0';
    img.style.opacity = i === 0 ? '1' : '0';
  });
  setInterval(() => {
    images[current].style.opacity = '0';
    current = (current + 1) % images.length;
    images[current].style.opacity = '1';
  }, 4000);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
